import { getVsicThunk } from '../../../common/category/store/thunk'

export const mapThunkCommon = {
  ALL_VSICS: 0,
}

export const thunkCommon = [
  {
    key: mapThunkCommon.ALL_VSICS,
    thunk: () => getVsicThunk(),
  },
]
